import { Component, OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Http} from "@angular/http";
//, Headers, RequestOptions, Response, ResponseContentType, URLSearchParams 
import { GlobalService } from '../../services/global.service';
import 'rxjs/add/operator/map';
import { AlertController } from 'ionic-angular';
import { LoadingController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { MyPosProvider } from '../../providers/my-pos/my-pos';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})

export class HomePage 
//implements OnInit 
{
SearchKey:string="";
NoRes:string="";
MyTitle:string="";
  list: Array<string>=[];//Item[] = [];
LLinth:string="";

UName2:string="";
  constructor(public navCtrl: NavController, private global: GlobalService,private http:Http
  ,public alertCtrl: AlertController,public loadingCtrl: LoadingController,private storage: Storage
  ,public PosProvider:MyPosProvider) {     
     //,public myApp: MyApp this.ngOnInit();   
    
  }
  data={
    id:1,name:"hisham"
  }

  presentLoading() {
    let loader = this.loadingCtrl.create({
      content: "Please wait...",
      duration: 3000,
    });
    loader.present();
  }
MyGet(MyK: string):void
{
  //http://service.sense-store.com/api/sense/GetItems/
  this.http.get('http://service.sense-store.com/api/sense/GetItems/'+MyK).map(res => res.json())
  .subscribe(data => {
    this.list = data;
  });
}
ClearLogOut(word){
  //this.storage.clear();
  
      this.storage.ready().then(
      () => {
        this.storage.remove(word);
      });
    
}
  showPrompt() {
    let prompt = this.alertCtrl.create({
      title: 'بحث',
      message: "اكتب جزء من الاسم واضغط بحث",
      inputs: [
        {
          name: 'MyT',
          placeholder: 'جزء من الاسم'
        },
      ],
      buttons: [
        {
          text: 'الغاء',
          handler: data => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'بحث',
          handler: data => {
         // console.log(data);
         // this.MyTitle=data.MyT;
         let loader = this.loadingCtrl.create({
          content: "Please wait...",
          //duration: 3000,
        });
        loader.present();
         // this.MyGet(data.MyT); 
         this.http.get(this.PosProvider.MyDomain+'/api/sense/GetItems/'+data.MyT)
         .map(res => res.json()).subscribe(data => {
           //if(data.lenth>100)
           //{
           // this.NoRes = "نتائج البحث اكثر من اللازم";
           // this.list=[];
           //}
           //else
           //{
           // this.NoRes ="";
              this.list = data;
           //}
         loader.dismiss();
  },err => {
    console.log(err);
    loader.dismiss();
    const alert = this.alertCtrl.create({
      title: 'Error message',
      subTitle: err,
      buttons: ['OK']
    });
    alert.present();
   });
          
          
          }
        }
      ]
    });
    prompt.present();
  }



}

export interface Item {
	empId?: number;
	empName?: string;
	empCity?: string;
}


// WEBPACK FOOTER //
// ./src/pages/home/home.ts